export enum EventFormStatusEnum {
  New = 1,
  Update = 2,
  Copy = 3,
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/event-form-status.enum.ts